import React from 'react';
import { Button, type ButtonProps } from './ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

interface DisabledTooltipProps {
  enabled: boolean;
  text?: string;
  children: React.ReactNode;
}

export const DisabledTooltip: React.FC<DisabledTooltipProps> = ({ enabled, text, children }) => {
  if (!enabled || !text) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex max-w-full">{children}</span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export const EmptyStateSecondaryButton = React.forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, 'variant' | 'size'> & { tooltip?: string }
>(({ children, disabled, tooltip, ...props }, ref) => {
  return (
    <DisabledTooltip enabled={Boolean(tooltip)} text={tooltip}>
      <Button ref={ref} {...props} variant="outline" size="default" disabled={disabled}>
        {children}
      </Button>
    </DisabledTooltip>
  );
});

EmptyStateSecondaryButton.displayName = 'EmptyStateSecondaryButton';
